module.exports = "img/cancel-red.3d9df3d.svg";